'use client';

import { useCallback, useRef } from 'react';
import { ELAPSED_FIELD, HONEYPOT_FIELD } from '@/lib/abuse-fields';

/**
 * Client half of the guard ladder: the honeypot field and the elapsed-time
 * measurement. Both are read server-side by lib/abuse.ts.
 *
 * `elapsedMs` is a DURATION, not a timestamp — a visitor with a badly wrong
 * system clock must not be permanently flagged.
 */
export function useFormGuard() {
  const mountedAt = useRef(Date.now());
  const honeypotRef = useRef<HTMLInputElement>(null);

  const guardFields = useCallback(
    () => ({
      [HONEYPOT_FIELD]: honeypotRef.current?.value ?? '',
      [ELAPSED_FIELD]: Date.now() - mountedAt.current,
    }),
    [],
  );

  const HoneypotField = useCallback(
    () => (
      <div aria-hidden="true" className="absolute left-[-9999px] top-0 h-0 w-0 overflow-hidden">
        <label htmlFor={HONEYPOT_FIELD}>Leave this field empty</label>
        <input
          ref={honeypotRef}
          id={HONEYPOT_FIELD}
          name={HONEYPOT_FIELD}
          type="text"
          tabIndex={-1}
          autoComplete="off"
          defaultValue=""
        />
      </div>
    ),
    [],
  );

  return { guardFields, HoneypotField };
}
